import { Injectable } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import type {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
} from '@angular/common/http';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpForceCamelCaseInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    req = req.clone({
      setHeaders: {
        Accept: `application/json-camelCase, application/json, text/plain, */*`,
      },
    });
    return next.handle(req);
  }
}
